import React from "react";
import "./App.css";

import "@smarthtmlelements/smart-elements/source/modules/smart.button.js";
import "@smarthtmlelements/smart-elements/source/modules/smart.sortable.js";

declare global {
  // eslint-disable-next-line
  namespace JSX {
    interface IntrinsicElements {
      "smart-sortable": any;
      "smart-check-box": any;
    }
  }
}

const App: React.FC = () => {
  document.readyState === 'complete' ? init() : window.onload = init;

  function init() {
    const sortable: any = document.getElementById("sortable");

    const handle: any = document.getElementById("handle");
    handle.addEventListener("change", function (event: any) {
      if (event.detail.value) {
        sortable.dragMode = "handle";
        sortable.handleVisibility = "visible";
      } else {
        sortable.dragMode = "item";
      }
    });
  }
  
  return (
    <div className="App">
      <em>Drag and drop to change list order</em>
      <smart-sortable id="sortable" items="li">
        <ol>
          <li>Strawberries</li>
          <li>Mango</li>
          <li>Watermelon</li>
          <li>Apples</li>
          <li>Bananas</li>
          <li>Grapes</li>
          <li>Pineapples</li>
          <li>Oranges</li>
          <li>Raspberries</li>
          <li>Peaches</li>
          <li>Cherries</li>
          <li>Kiwi</li>
          <li>Blueberries</li>
          <li>Pomegranate</li>
          <li>Lemons</li>
        </ol>
      </smart-sortable>
      <div className="options">
        <smart-check-box id="handle">
          <code>drag-mode="handle"</code>
        </smart-check-box>
      </div>
    </div>
  );
}

export default App;
